import { ApiProperty } from '@nestjs/swagger';

/**
 * Enum de servicios disponibles en vwServiceOrders.
 * Keys normalizadas en camelCase (estándar JSON/REST), valores son los nombres en base de datos.
 * @see vwServiceOrders.ServiceName
 */
export const ServiceName = {
  /** Aclaracion Manifiestos */
  aclaracionManifiestos: 'Aclaracion Manifiestos',
  /** AFORO FISICO */
  aforoFisico: 'AFORO FISICO',
  /** Agenciamiento Terrestre Pallets */
  agenciamientoTerrestrePallets: 'Agenciamiento Terrestre Pallets',
  /** Almacenaje */
  almacenaje: 'Almacenaje',
  /** Almacenaje Full CNTR DRY */
  almacenajeFullCntrDry: 'Almacenaje Full CNTR DRY',
  /** Almacenaje Full Reefers */
  almacenajeFullReefers: 'Almacenaje Full Reefers',
  /** Asistencia Tecnica */
  asistenciaTecnica: 'Asistencia Tecnica',
  /** Bl Fee */
  blFee: 'Bl Fee',
  /** Cambio de Sellos */
  cambioDeSellos: 'Cambio de Sellos',
  /** Cambio de Tipo de Liberación Booking */
  cambioTipoLiberacionBooking: 'Cambio de Tipo de Liberación Booking',
  /** Cambio Puerto Destino */
  cambioPuertoDestino: 'Cambio Puerto Destino',
  /** Carta de Temperatura */
  cartaDeTemperatura: 'Carta de Temperatura',
  /** Certificado de Origen Sofofa */
  certificadoOrigenSofofa: 'Certificado de Origen Sofofa',
  /** Certificado de Origen Ucco */
  certificadoOrigenUcco: 'Certificado de Origen Ucco',
  /** Certificado de Origen Ucco (CHINA-EUR) */
  certificadoOrigenUccoChinaEur: 'Certificado de Origen Ucco (CHINA-EUR)',
  /** Certificado de Origen Ucco (FGN) */
  certificadoOrigenUccoFgn: 'Certificado de Origen Ucco (FGN)',
  /** Certificado Extra de Origen Ucco */
  certificadoExtraOrigenUcco: 'Certificado Extra de Origen Ucco',
  /** Certificado Extra de Origen Ucco (CHINA-EUR) */
  certificadoExtraOrigenUccoChinaEur:
    'Certificado Extra de Origen Ucco (CHINA-EUR)',
  /** Certificado Extra de Origen Ucco (FGN) */
  certificadoExtraOrigenUccoFgn: 'Certificado Extra de Origen Ucco (FGN)',
  /** Certificado Extra Fitosanitario */
  certificadoExtraFitosanitario: 'Certificado Extra Fitosanitario',
  /** Certificado Fitosanitario */
  certificadoFitosanitario: 'Certificado Fitosanitario',
  /** Comisión bancaria pagos en dólares */
  comisionBancariaPagosDolares: 'Comisión bancaria pagos en dólares',
  /** Confeccion y declaracion Matriz */
  confeccionDeclaracionMatriz: 'Confeccion y declaracion Matriz',
  /** Control sello */
  controlSello: 'Control sello',
  /** Correccion de BL */
  correccionDeBl: 'Correccion de BL',
  /** Declaracion IVV */
  declaracionIvv: 'Declaracion IVV',
  /** Desconsolidado de Contenedor */
  desconsolidadoDeContenedor: 'Desconsolidado de Contenedor',
  /** Devolución en depósito */
  devolucionEnDeposito: 'Devolución en depósito',
  /** Diferencia tarifa flete */
  diferenciaTarifaFlete: 'Diferencia tarifa flete',
  /** Doc Fee Difference Booking */
  docFeeDifferenceBooking: 'Doc Fee Difference Booking',
  /** Dus Legalizado */
  dusLegalizado: 'Dus Legalizado',
  /** Dus Legalizado Fuera de Plazo */
  dusLegalizadoFueraDePlazo: 'Dus Legalizado Fuera de Plazo',
  /** Emisión BL */
  emisionBl: 'Emisión BL',
  /** Envio Encomienda Internacional */
  envioEncomiendaInternacional: 'Envio Encomienda Internacional',
  /** Envio Encomiendas Nacional */
  envioEncomiendasNacional: 'Envio Encomiendas Nacional',
  /** Exceso de Recursos Contenedor */
  excesoRecursosContenedor: 'Exceso de Recursos Contenedor',
  /** Exceso de Recursos Pallet */
  excesoRecursosPallet: 'Exceso de Recursos Pallet',
  /** Export Fee */
  exportFee: 'Export Fee',
  /** Extra Underslung */
  extraUnderslung: 'Extra Underslung',
  /** Falso Flete en deposito */
  falsoFleteEnDeposito: 'Falso Flete en deposito',
  /** Falso Flete en planta */
  falsoFleteEnPlanta: 'Falso Flete en planta',
  /** Falso Flete full retorno */
  falsoFleteFullRetorno: 'Falso Flete full retorno',
  /** Falso Flete ruta a planta */
  falsoFleteRutaAPlanta: 'Falso Flete ruta a planta',
  /** Generador o Conexión */
  generadorOConexion: 'Generador o Conexión',
  /** Gestión en Deposito */
  gestionEnDeposito: 'Gestión en Deposito',
  /** Gestión por anulacion de gate out */
  gestionAnulacionGateOut: 'Gestión por anulacion de gate out',
  /** Habilitación Deposito */
  habilitacionDeposito: 'Habilitación Deposito',
  /** Habilitación SAG */
  habilitacionSag: 'Habilitación SAG',
  /** Ingreso Anticipado Reefer */
  ingresoAnticipadoReefer: 'Ingreso Anticipado Reefer',
  /** Ingreso en Puerto Tardío */
  ingresoPuertoTardio: 'Ingreso en Puerto Tardío',
  /** Inspección Scanner */
  inspeccionScanner: 'Inspección Scanner',
  /** Interplanta */
  interplanta: 'Interplanta',
  /** Late Arrival */
  lateArrival: 'Late Arrival',
  /** Liberacion Via Email */
  liberacionViaEmail: 'Liberacion Via Email',
  /** Manipuleo */
  manipuleo: 'Manipuleo',
  /** Manipuleo Full Reefer TLS */
  manipuleoFullReeferTls: 'Manipuleo Full Reefer TLS',
  /** Matrices */
  matrices: 'Matrices',
  /** Matriz Fuera de Plazo */
  matrizFueraDePlazo: 'Matriz Fuera de Plazo',
  /** Muestra Usda */
  muestraUsda: 'Muestra Usda',
  /** Multa Aduana */
  multaAduana: 'Multa Aduana',
  /** Multa Aduana Plts. */
  multaAduanaPlts: 'Multa Aduana Plts.',
  /** Multa por pesaje */
  multaPorPesaje: 'Multa por pesaje',
  /** Pago Tardío de BL Export */
  pagoTardioBlExport: 'Pago Tardío de BL Export',
  /** Permanencia en Zona de Custodia Zeal */
  permanenciaZonaCustodiaZeal: 'Permanencia en Zona de Custodia Zeal',
  /** Personal Externo Los Andes */
  personalExternoLosAndes: 'Personal Externo Los Andes',
  /** Pesaje en Puerto */
  pesajeEnPuerto: 'Pesaje en Puerto',
  /** Porteo Entrega Zeal */
  porteoEntregaZeal: 'Porteo Entrega Zeal',
  /** Porteo Full */
  porteoFull: 'Porteo Full',
  /** Porteo Full CNTR DRY (IMO) */
  porteoFullCntrDryImo: 'Porteo Full CNTR DRY (IMO)',
  /** Porteo Full Reefers SAI */
  porteoFullReefersSai: 'Porteo Full Reefers SAI',
  /** Porteos */
  porteos: 'Porteos',
  /** Pre- Asignación */
  preAsignacion: 'Pre- Asignación',
  /** Providencia de Aduana */
  providenciaDeAduana: 'Providencia de Aduana',
  /** Re Facturación Servicios */
  reFacturacionServicios: 'Re Facturación Servicios',
  /** Re Liquidación DUS */
  reLiquidacionDus: 'Re Liquidación DUS',
  /** Recepción Fuera Horario en Terminal */
  recepcionFueraHorarioTerminal: 'Recepción Fuera Horario en Terminal',
  /** Reposición de cortina atmósfera controlada */
  reposicionCortinaAtmosferaControlada:
    'Reposición de cortina atmósfera controlada',
  /** Retiro Contenedor Desde Stacking */
  retiroContenedorDesdeStacking: 'Retiro Contenedor Desde Stacking',
  /** Retiro cruzado */
  retiroCruzado: 'Retiro cruzado',
  /** Retiro Deposito Santiago */
  retiroDepositoSantiago: 'Retiro Deposito Santiago',
  /** Retiro Fisico BL o Documentos */
  retiroFisicoBlDocumentos: 'Retiro Fisico BL o Documentos',
  /** Rotulado carga IMO */
  rotuladoCargaImo: 'Rotulado carga IMO',
  /** Scanner Aduana */
  scannerAduana: 'Scanner Aduana',
  /** Security Fee Contenedor */
  securityFeeContenedor: 'Security Fee Contenedor',
  /** Security Fee Pallet */
  securityFeePallet: 'Security Fee Pallet',
  /** Segundo Tramo Extra Transporte Cntr */
  segundoTramoExtraTransporteCntr: 'Segundo Tramo Extra Transporte Cntr',
  /** Sellos */
  sellos: 'Sellos',
  /** Servicio de Permanencia */
  servicioDePermanencia: 'Servicio de Permanencia',
  /** Servicio Gate In */
  servicioGateIn: 'Servicio Gate In',
  /** Servicio Gate Out */
  servicioGateOut: 'Servicio Gate Out',
  /** SLOT HORA */
  slotHora: 'SLOT HORA',
  /** Sobre peso de carga */
  sobrePesoDeCarga: 'Sobre peso de carga',
  /** Sobrepeso */
  sobrepeso: 'Sobrepeso',
  /** Sobrestadia en depósito */
  sobrestadiaEnDeposito: 'Sobrestadia en depósito',
  /** Sobrestadia en planta */
  sobrestadiaEnPlanta: 'Sobrestadia en planta',
  /** Sobrestadia en puerto */
  sobrestadiaEnPuerto: 'Sobrestadia en puerto',
  /** Transporte de Importación */
  transporteDeImportacion: 'Transporte de Importación',
  /** Tratamiento de Frio */
  tratamientoDeFrio: 'Tratamiento de Frio',
  /** Uso Anden en Zeal */
  usoAndenEnZeal: 'Uso Anden en Zeal',
  /** Visto Bueno Naviera */
  vistoBuenoNaviera: 'Visto Bueno Naviera',
} as const;

/** Tipo de las keys normalizadas del enum ServiceName */
export type ServiceNameKey = keyof typeof ServiceName;

/** Tipo de los valores (nombres en base de datos) del enum ServiceName */
export type ServiceNameValue = (typeof ServiceName)[ServiceNameKey];

/** Array de todos los valores de servicios para uso en validaciones y Swagger */
export const SERVICE_NAME_VALUES = Object.values(ServiceName);

/** Array de todas las keys normalizadas para uso en validaciones */
export const SERVICE_NAME_KEYS = Object.keys(ServiceName) as ServiceNameKey[];

export class ServiceNameDto {
  @ApiProperty({ description: 'Service id from vwServiceOrders', example: 33 })
  serviceId!: number;

  @ApiProperty({
    description: 'Service name from vwServiceOrders',
    example: ServiceName.almacenaje,
    enum: SERVICE_NAME_VALUES,
  })
  serviceName!: string;
}

export class VesselNameDto {
  @ApiProperty({ description: 'Vessel id from vwServiceOrders', example: 5034 })
  vesselId!: number;

  @ApiProperty({
    description: 'Vessel name from vwServiceOrders',
    example: 'A.P. MOLLER',
  })
  vesselName!: string;
}

export class InvoicingTypeDto {
  @ApiProperty({
    description: 'Type of invoicing id from vwServiceOrders',
    example: 2,
  })
  typeOfInvoicingId!: number;

  @ApiProperty({
    description: 'Type of invoicing name from vwServiceOrders',
    example: 'Traspaso',
  })
  typeOfInvoicingName!: string;
}
